import { useState, useCallback } from 'react';

export default function useChartLegend() {
  const [activeItem, setActiveItem] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);

  const handleClick = useCallback((item) => {
    setActiveItem((prevActiveItem) =>
      prevActiveItem?.id === item.id ? null : item
    );
  }, []);

  const handleMouseOver= useCallback((item) => {
    setHoveredItem((prevHoveredItem) =>
      prevHoveredItem?.id === item.id ? null : item
    );
  }, []);

  const handleMouseOut = useCallback(() => {
    setHoveredItem(null);
  }, []);

  const classesToAdd = (key) =>
    activeItem?.id && (activeItem.id === key ? 'active-series' : 'inactive-series')
    || hoveredItem?.id && (hoveredItem.id === key ? 'hovered-series' : 'inactive-series');

  return {
    activeItem,
    hoveredItem,
    onClick: handleClick,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    classesToAdd,
  }
};
